<div class="container-fluid padMob" style="padding-left: 15px; padding-right: 15px;">
    <div class="row">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-bottom: 0px;">
            <span class="Mobi" style="font-size: 22px; margin-right: 10px;" class="mobView">
                <i class="fa fa-chevron-left" (click)="goBack()"></i></span>
            <h4 style="display: inline-block; ">{{prTypeID == 1 ? 'Production Target' : 'Project Target'}}</h4>  
            <div class="btn btn-orange brdrRadius3" (click)="openTransaction(8)" style="padding: 6px 12px 5px;; font-size: 14px; line-height: 1.66em; float: right;">
                <i class="fa fa-sign-in" aria-hidden="true">
                   </i>
            </div>  
        </div>

        <div class="col-md-6 col-sm-12 col-12 headerPadding">
            <!-- Basic Data -->
           <div class="col-md-12 col-12 col-sm-12 orangeBckNew" style="padding-top: 10px; margin-top: 10px; padding-left: 10px; margin-bottom: 5px;">
                <div>
                    <div style="margin-top: 8px;">
                        <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-left: 5px; margin-bottom: 10px;">
                            WIP <span style="font-size: 13px; font-weight: 200;font-weight: bold;"> {{productionOutData[0]?.JobNo}} </span>
                        </span>

                        <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-left: 10px; margin-bottom: 10px;">
                            Due Date <span style="font-size: 13px; font-weight: 600;"> {{productionOutData[0]?.TargetDT | date: 'dd-MMM-yy'}}</span>
                        </span>

                        <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="font-size: 13px;margin-left: 10px; margin-bottom: 10px;" *ngIf="jobDetails[0]?.CstrRelName != ''">
                            <span>{{productionOutData[0]?.CstrRelName}}</span>
                        </span>
                        
                        <span class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-left: 10px; margin-bottom: 0px; font-size: 12px; padding: 6px 15px;" *ngIf="jobDetails[0]?.Instructions != ''">
                            {{productionOutData[0].Instructions}}
                        </span>
                        
                        <span *ngIf="productionOutData[0]?.Attachment != ''" (click)="viewFile()" class="darkBlueBadge brdrRadius3 bgwhite darkBlueBrdr" style="margin-left: 10px; margin-bottom: 10px;">
                            <i class="fa fa-file" style="margin-right: 5px;"></i> Descriptor File
                        </span>
                    </div> 
                </div>
            </div>
        </div>

         <!-- Production Target -->
         <div class="col-md-12 col-12 col-sm-12 yellowBckNew" style="padding-top: 10px; 
         padding-bottom: 10px; margin-top: 10px;">
             <div style="font-size: 15px;margin-left: 5px;">
             <span class="darkBlueText">{{prTypeID == 1 ? 'Production Target' : 'Project Target'}}</span>
                    
             </div>
             <div>
                 <div *ngFor="let i of productItemsTarget; let j = index" style="width:100%;padding-left: 10px; margin-top: 8px;">
                     <div style="margin-top: 5px; font-size: 13px; color: #777; width: 100%;">
                        <div style="display: inline-block; width: {{prTypeID == 1 ? '35%' : '100%'}}; font-size: 13px; color: #777;">
                             {{i.ItemName}}</div>  
                            <div *ngIf="prTypeID == 1" style="display: inline-block; width: 65%;text-align: right;">
                                <span *ngIf="!i.IsSelect" style="margin-right: 5px;"> {{i.PlanQty}}</span>   
                                    <span *ngIf="i.IsSelect">

                                        <input type="text" id="txtItem" [(ngModel)]="i.PlanQty" class="form-control"
                                        tabindex="1" placeholder="Qty" 
                                        style="height: 20px; padding: 13px;width: 80px; display: inline-block; background: inherit; text-align: right;"
                                        maxlength="50" />
                                    </span>

                                    <span>{{i.SKU}}</span>
                                    <span class="" *ngIf="productItemsTarget.length > 1;" (click)="deleteItems(i)" style="padding: 2px 7px 2px; border-radius: 10px; color: gray; cursor: pointer;"><i class="fa fa-trash-o"></i></span>
                                    <span class="" style="padding: 2px 7px 2px; border-radius: 10px; color: #e88421; cursor: pointer;" *ngIf="!i.IsSelect;" (click)="editQty(i, j)"><i class="fa fa-pencil" ></i></span>
                                    <span class="" style="padding: 2px 7px 2px; border-radius: 10px; color: #4caf50; cursor: pointer;" *ngIf="i.IsSelect" (click)="saveItem()" ><i class="fa fa-check"></i></span>
                                    <span class="" style="padding: 2px 7px 2px; border-radius: 10px; color: gray; cursor: pointer; padding-left: 0px;" *ngIf="i.IsSelect" (click)="cancel(i)" ><i class="fa fa-times"></i></span> 
                            </div>
                        
                         <!-- <div style="display: inline-block; width: 10%; text-align: right;" *ngIf="i.GenQty == 0">
                            <span class="lableBtnGray" style="padding: 2px 7px 2px; border-radius: 10px;"><i class="fa fa-trash"></i></span>
                         </div> -->
                     </div>
                     <div *ngIf="prTypeID == 1" style="margin-top: 8px; font-size: 13px; color: #777;">
                         <div style="display: inline-block; width: 100%;">
                             <span class="orangeBadgeNew brdrRadius3" style="margin: 0px 10px 10px 0px;" *ngIf="i.TempPlanQty > 0">
                                 Plan {{i.TempPlanQty}}  
                                 <!-- <span>{{i.Units}}</span> -->
                                 <!-- <span class="fa fa-pencil" style="margin-left: 10px;"></span> -->
                             </span>
                             <span class="orangeBadgeNew brdrRadius3" style="margin: 0px 10px 10px 0px;" *ngIf="i.GenQty > 0">
                                 Done {{i.GenQty}} 
                                 <!-- <span>{{i.Units}}</span> -->
                             </span>
                             <span class="orangeBadgeNew brdrRadius3" style="margin: 0px 10px 10px 0px;" *ngIf="i.RejQty > 0">
                                Rej {{i.RejQty}} 
                                <!-- <span>{{i.Units}}</span> -->
                            </span>
                             <span class="orangeBadgeNew brdrRadius3" style="margin: 0px 10px 10px 0px;" *ngIf="(i.TempPlanQty - (i.GenQty  + i.RejQty )) > 0">
                                 WIP {{i.TempPlanQty - (i.GenQty  + i.RejQty )}}
                                 <!-- <span>{{i.Units}}</span> -->
                             </span>
                         </div>
                     </div>
                      <!-- Expence Add and Show -->
                      <div *ngIf="prTypeID == 2" style="margin-top: 15px; font-size: 15px; color: #777; padding-bottom: 10px;">
                        <div style="display: inline-block; width: 100%; margin-left: -5px;">
                            <span class="greenBadge brdrRadius3"(click)="costTypeListMdl()" style="margin-right: 10px; font-size: 12px; padding: 6px 15px;" >
                                Total Expense <span style="margin-right:5px;">₹ {{costSum | lacFormat : 1 }} </span>
                            </span>
                            <span *ngIf="prTypeID == 2 && rights.prdCfg && rights.allPrd"class="tealBadge brdrRadius3" (click)="costTypeEntryMDl()" style="margin-right: 10px; font-size: 12px; padding: 6px 15px;">
                                <i class="fa fa-plus" style="margin-right:5px"></i>Enter Expense 
                            </span>
                        </div>
                        </div>
                 </div>
             </div>
         </div>

         <!-- Byproduct -->
         <!-- <div class="col-md-12 col-12 col-sm-12 greenBckNew" style="padding-top: 10px; 
         padding-bottom: 10px; margin-top: 10px;">
             <div style="font-size: 19px;">
                 <span>Byproducts & Scrap</span>
                 <span style="float: right; font-size: 20px; cursor: pointer;" class="webView">
                     <i class="zmdi zmdi-plus"></i>
                 </span>
                 <span style="float: right; font-size: 20px; cursor: pointer;" class="mobView">
                     <i class="zmdi zmdi-plus"></i>
                 </span>
             </div>             *ngFor="let i of productionOutData.productsJobs"
         </div> -->
    </div>
</div>